import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import { Link } from 'react-router-dom';

const HeroSlider = () => {
  const slides = [
    {
      id: 1,
      subtitle: 'Freshness in Every Bite',
      title: 'Seasonal Fruits',
      description: 'Seasonal fruits are harvested at their natural peak, so they are typically fresher, more flavorful, and richer in vitamins, minerals, and antioxidants than fruits grown out of season or stored for long periods',
      image: '/assets/img/slider/home1-slider1-layer.png',
      imageClass: 'slider__layer--img'
    },
    {
      id: 2,
      subtitle: 'Nutrient-Packed Leafy Powerhouse',
      title: 'Green Collards',
      description: 'A cruciferous leafy green, deliver exceptional nutrition including vitamins A, C, and K, calcium, folate, fiber, and antioxidants that combat oxidative stress and support overall health',
      image: '/assets/img/slider/home1-slider2-layer.png',
      imageClass: 'slider__layer--img home1__slider--layer2__img'
    },
    {
      id: 3,
      subtitle: 'Nature’s Healing Pharmacy',
      title: 'Medicinal Plants',
      description: 'Used since prehistoric times in traditional practices like Ayurveda and TCM, contain bioactive compounds such as polyphenols, alkaloids, and antioxidants that offer anti-inflammatory, antimicrobial, and immune-boosting effects',
      image: '/assets/img/slider/home1-slider3-layer.png',
      imageClass: 'slider__layer--img'
    }
  ];

  return (
    <section className="hero__slider--section">
      <div className="hero__slider--inner hero__slider--activation">
        <Swiper
          modules={[Pagination, Autoplay]}
          spaceBetween={30}
          slidesPerView={1}
          loop={true}
          speed={500}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          pagination={{
            el: '.slider__pagination',
            clickable: true,
          }}
          className="hero__slider--wrapper"
        >
          {slides.map((slide) => (
            <SwiperSlide key={slide.id}>
              <div className="hero__slider--items bg__gray--color">
                <div className="container slider__items--container">
                  <div className="hero__slider--items__inner">
                    <div className="row row-cols-lg-2 row-cols-md-2 row-cols-1 align-items-center">
                      <div className="col">
                        <div className="slider__content slider__content--padding__left">
                          <span className="slider__content--subtitle text__secondary">
                            {slide.subtitle}
                          </span>
                          <h2 className="slider__content--maintitle h1">
                            {slide.title}
                          </h2>
                          <p className="slider__content--desc">{slide.description}</p>
                          <Link className="btn slider__btn" to="/shop">Shop Now</Link>
                        </div>
                      </div>
                      <div className="col">
                        <div className={`hero__slider--layer ${slide.id === 2 ? 'home1__slider--layer2' : ''}`}>
                          <img 
                            className={slide.imageClass} 
                            src={slide.image} 
                            alt="slider-img" 
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        <div className="slider__pagination swiper-pagination"></div>
      </div>
    </section>
  );
};

export default HeroSlider;
